import {
  AppPageHeader,
  EditIcon,
  Group,
  InfiniteTable,
} from '@/components/_common';
import { useInstallmentTagsList } from '@/core/domain/financial/InstallmentTags/InstallmentTags.hooks';
import {
  InstallmentTag,
  InstallmentTagsQueryFilter,
} from '@/core/domain/financial/InstallmentTags/InstallmentTags.type';
import { CheckOutlined } from '@ant-design/icons';
import { useDebounce, useDisclosure, useWindowSize } from '@/hooks';
import { flatInfiniteData } from '@/utils/request/flatInfiniteData';
import { Button, Divider, Modal, ModalProps, Space, Tag } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import { useState } from 'react';
import ModalLoadingOverlay from '@/components/_common/ModalLoadingOverlay';
import TagsAccountsPayableAndReceivableModal from '../TagsAccountsPayableAndReceivableModal';

export interface Props extends Omit<ModalProps, 'onCancel'> {
  onCallback: (tagId: number) => void;
  onCancel: () => void;
}

export default function TagsAccountsPayableAndReceivableSelectModal(
  props: Props,
) {
  const { isMobile } = useWindowSize();

  const [queryParams, setQueryParams] = useState<InstallmentTagsQueryFilter>({
    order: 'ASC',
  });

  const queryDebounce = useDebounce(queryParams, 500);

  const list = useInstallmentTagsList(queryDebounce, props.open);

  const [modalOpened, modalActions] = useDisclosure();
  const [tagSelected, setTagSelected] = useState<InstallmentTag>();

  const workOrderTags = flatInfiniteData(list.data);

  function handleCallback(tagId: number) {
    props.onCallback(tagId);
    props.onCancel();
  }

  const columns: ColumnsType<InstallmentTag> = [
    {
      dataIndex: 'name',
      title: 'Descrição',
      render: (_, record) => (
        <Tag color={record.color}>{record.name.toUpperCase()}</Tag>
      ),
    },
    {
      dataIndex: 'actions',
      align: 'right',
      render: (_, row) => (
        <Space direction="horizontal" size="middle" style={{ display: 'flex' }}>
          <EditIcon
            size={24}
            iconProps={{
              onClick: () => {
                setTagSelected(row);
                modalActions.open();
              },
            }}
          />

          <Divider type="vertical" />

          <Button
            type="primary"
            onClick={() => handleCallback(row.id)}
            icon={<CheckOutlined />}
          />
        </Space>
      ),
      width: '20%',
    },
  ];
  return (
    <>
      <Modal
        {...props}
        title="Seleção de etiqueta"
        footer={[]}
        onCancel={props.onCancel}
      >
        {props.confirmLoading && (
          <ModalLoadingOverlay
            style={{
              position: 'absolute',
              width: '100%',
              height: '100%',
              backdropFilter: 'blur(2px)',
            }}
            messages={['Incluindo Etiqueta...']}
          />
        )}

        <Group
          position="between"
          align="center"
          gap={24}
          style={{ flexDirection: isMobile ? 'column' : undefined }}
        >
          <AppPageHeader
            searchValue={queryParams.search}
            onSearch={(value) =>
              setQueryParams((prev) => ({ ...prev, search: value }))
            }
          />

          <Button
            type="primary"
            onClick={modalActions.open}
            style={{ marginBottom: 24 }}
          >
            Criar Etiqueta
          </Button>
        </Group>

        <InfiniteTable<InstallmentTag>
          columns={columns}
          dataSource={workOrderTags}
          loading={list.isFetching}
          rowKey={(row) => row.id}
          hasNextPage={list.hasNextPage}
          fetchNextPage={list.fetchNextPage}
        />
      </Modal>

      <TagsAccountsPayableAndReceivableModal
        tagDetail={tagSelected}
        open={modalOpened}
        onCancel={() => {
          setTagSelected(undefined);
          modalActions.close();
        }}
      />
    </>
  );
}
